import { IWoundMeasurement } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { WoundMeasurementWorkItem } from 'src/app/business/wound-measurement/wound-measurement-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class WoundMeasurementCommandHandler extends EntityCommandHandler<IWoundMeasurement> {
  protected workItem: IWorkItem<IWoundMeasurement>;

  constructor(woundMeasurementWorkItem: WoundMeasurementWorkItem) {
    super();
    this.workItem = woundMeasurementWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'WoundMeasurementDto';
  }
}
